import React, { useState } from 'react';
import Table from 'antd/es/table';
import { useStore, useUnit } from 'effector-react';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Button, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  $servicesActiveTab,
  $userInfo,
  changeServiceActiveTabEv,
  payOCHVEv,
  payOCHVFx,
} from '../../models/authModel/index.js';
import FreeServicesTable from './FreeServicesTable.jsx';
import PaidServicesTable from './PaidServicesTable.jsx';
import PremiumAtameken from './PremiumAtameken.jsx';

const dataSource = [
  {
    id: '1',
    paid: false,
    name: 'Представление, защита прав и законных интересов субъектов предпринимательства в государственных органах Республики Казахстан, а также международных организациях и зарубежных государствах в соответствии с Законом РК «О Национальной палате предпринимателей Республики Казахстан», иными нормативными правовыми актами и уставом НПП РК; ',
  },
  {
    id: '2',
    paid: false,
    name: 'представление интересов предпринимательства в Правительстве Республики Казахстан, Парламенте Республики Казахстан и других государственных органах; ',
  },
  {
    id: '3',
    paid: false,
    name: 'принятие участия в разработке нормативных правовых актов, затрагивающих интересы субъектов предпринимательства, за исключением проектов нормативных правовых актов центральных и местных исполнительных органов, а также акимов, предусматривающих принятие решений об установлении (отмене) карантинной зоны с введением карантинного режима на соответствующей территории, об установлении (снятии) карантина и (или) ограничительных мероприятий в случаях, предусмотренных законодательством Республики Казахстан в области ветеринарии, а также объявление чрезвычайной ситуации природного и техногенного характера; ',
  },
  {
    id: '4',
    paid: false,
    name: 'осуществление обязательной экспертизы концепций проектов законов, проектов законодательных и иных нормативных правовых актов, затрагивающих интересы субъектов частного предпринимательства, за исключением проектов нормативных правовых актов центральных и местных исполнительных органов, а также акимов, предусматривающих принятие решений об установлении (отмене) карантинной зоны с введением карантинного режима на соответствующей территории, об установлении (снятии) карантина и (или) ограничительных мероприятий в случаях, предусмотренных законодательством Республики Казахстан в области ветеринарии, а также объявление чрезвычайной ситуации природного и техногенного характера; ',
  },
  {
    id: '5',
    paid: false,
    name: 'осуществление разработки и внесение в Правительство Республики Казахстан предложений по вопросам передачи в конкурентную среду функций центральных и (или) местных исполнительных органов в сфере предпринимательской деятельности, за исключением функций государственного регулирования деятельности финансовых организаций и финансового рынка; ',
  },
  {
    id: '6',
    paid: false,
    name: 'Пункты 3,4,5 изложены в соответствии с решением Съезда от 29.10.2020 г. Протокол №7 ',
  },
  {
    id: '7',
    paid: false,
    name: 'принятие участия в работе коллегиальных консультативно совещательных органов при центральных и местных государственных органах, создаваемых по вопросам, затрагивающим права и обязанности предпринимателей; ',
  },
  {
    id: '8',
    paid: false,
    name: 'проведение общественных слушаний по вопросам предпринимательства; ',
  },
  {
    id: '9',
    paid: false,
    name: 'осуществление общественного мониторинга; ',
  },
  {
    id: '10',
    paid: false,
    name: 'внесение в Правительство Республики Казахстан предложения по совершенствованию деятельности центральных и местных государственных органов по вопросам предпринимательства; ',
  },
  {
    id: '11',
    paid: false,
    name: 'участие в проведении оценки эффективности корпоративного управления в контролируемых государством акционерных обществах; ',
  },
  {
    id: '12',
    paid: false,
    name: 'осуществление на регулярной основе подготовки и ведения независимого рейтинга «Деловой климат»; ',
  },
  {
    id: '13',
    paid: false,
    name: 'обеспечение информацией общество и государство о состоянии предпринимательской активности путем подготовки и опубликования ежегодного национального доклада о состоянии предпринимательской активности в Республике Казахстан; ',
  },
  {
    id: '14',
    paid: false,
    name: 'проведение на регулярной основе сбора, обобщения и анализа информации о соблюдении государственными органами и (или) государственными служащими прав и законных интересов субъектов предпринимательства; ',
  },
  {
    id: '15',
    paid: false,
    name: 'принятие участия в управлении специальными экономическими зонами; ',
  },
  {
    id: '16',
    paid: false,
    name: 'по согласованию с уполномоченным органом в области транспорта и коммуникаций принятие участия в обеспечении строительства (реконструкции), функционирования (эксплуатации) объектов инфраструктуры пунктов пропуска Республики Казахстан, в том числе сервисной (таможенной) инфраструктуры, включая их оборудование и техническое оснащение (за исключением специального оборудования государственных контрольных органов), а также содержание и ремонт зданий, помещений и сооружений, необходимых для организации в указанных пунктах пропуска пограничного, таможенного видов контроля, путем привлечения инвестиций; ',
  },
  {
    id: '17',
    paid: false,
    name: 'осуществление анализа и обобщения практики корпоративного управления; ',
  },
  {
    id: '18',
    paid: false,
    name: 'организация и проведение конкурса на соискание премии Президента Республики Казахстан «Алтын сапа» и конкурс-выставку «Лучший товар Казахстана; ',
  },
  {
    id: '19',
    paid: false,
    name: 'осуществление функции оператора нефинансовой поддержки физических лиц, претендующих на занятие предпринимательской деятельностью, и субъектов предпринимательства, включая сервисную поддержку предпринимателей, предусмотренные документами Системы государственного планирования Республики Казахстан;',
  },
  {
    id: '20',
    paid: false,
    name: 'принятие участия в разработке стандартов и технических регламентов и обеспечение их соблюдения предпринимателями в соответствии с законодательством Республики Казахстан; ',
  },
  {
    id: '21',
    paid: false,
    name: 'принятие участия в разработке современных стандартов таможенной инфраструктуры в целях улучшения оказания услуг в сфере таможенного дела в соответствии с законодательством Республики Казахстан; ',
  },
  {
    id: '22',
    paid: false,
    name: 'принятие участия в разработке уполномоченными государственными органами национальных топливно-энергетических балансов, реализации и потреблении сырья и товаров в отраслях экономики; ',
  },
  {
    id: '23',
    paid: false,
    name: 'создание и осуществление поддержки, администрирования и развития единого интернет-портала для субъектов предпринимательства; ',
  },
  {
    id: '24',
    paid: false,
    name: 'в порядке, предусмотренном нормативными правовыми актами, принятие участия в осуществлении мер по поддержке отечественного производства и повышению доли местного содержания в закупках; ',
  },
  {
    id: '25',
    paid: false,
    name: 'принятие участия в осуществлении мониторинга исполнения контрактных обязательств недропользователями в части местного содержания в товарах, работах, услугах, кадрах и социального развития территорий; ',
  },
  {
    id: '26',
    paid: false,
    name: 'ведение рейтинга поставщиков товаров, работ, услуг; ',
  },
  {
    id: '27',
    paid: false,
    name: 'анализ действующей правовой базы и условий, связанных с участием Республики в международных организациях и подготовка отчетов, рекомендаций по совершенствованию казахстанского законодательства; ',
  },
  {
    id: '27-1',
    paid: false,
    name: 'принятие участия в разработке отраслевых рамок квалификаций, утверждение профессиональных стандартов; ',
  },
  {
    id: '28',
    paid: false,
    name: 'Пункт 27 изложен в соответствии с решением Съезда от 29.10.2020 г. Протокол №7',
  },
  {
    id: '29',
    paid: false,
    name: 'утверждение единых и (или) межотраслевых типовых норм и нормативов по труду для всех сфер деятельности;',
  },
  {
    id: '30',
    paid: false,
    name: 'Пункт 27-1 дополнен в соответствии с решением Съезда от 29.10.2020 г. Протокол №7 ',
  },
  {
    id: '31',
    paid: false,
    name: 'принятие участия в государственной аттестации организаций технического и профессионального образования, за исключением автономных организаций образования; ',
  },
  {
    id: '32',
    paid: false,
    name: 'принятие участия в работе консультативно-совещательного органа по лицензированию образовательной деятельности юридических лиц, реализующих образовательные учебные программы технического и профессионального образования; ',
  },
  {
    id: '33',
    paid: false,
    name: 'принятие участия в коллегиальных органах управления государственных организаций технического и профессионального образования по согласованию, за исключением автономных организаций образования; ',
  },
  {
    id: '34',
    paid: false,
    name: 'внесение предложения для формирования и размещения государственного заказа на подготовку кадров в соответствии с потребностями рынка труда отраслей экономики; ',
  },
  {
    id: '35',
    paid: false,
    name: 'принятие участия в деятельности отраслевых и региональных советов по развитию технического и профессионального образования и подготовке кадров; ',
  },
  {
    id: '36',
    paid: false,
    name: 'принятие участия в разработке учебно-методических материалов, в том числе государственных общеобязательных стандартов образования, образовательных учебных программ и планов технического и профессионального образования; ',
  },
  {
    id: '36-1',
    paid: false,
    name: 'проведение мониторинга потребности субъектов предпринимательства в профессиональных кадрах; ',
  },
  {
    id: '37',
    paid: false,
    name: 'разработка и реализация мероприятий по содействию трудоустройству специалистов; ',
  },
  {
    id: '38',
    paid: false,
    name: 'создание учебных центров по профессиональной подготовке, переподготовке, повышению квалификации и присвоению квалификации по профессиям (специальностям) технического и обслуживающего труда; ',
  },
  {
    id: '39',
    paid: false,
    name: 'формирование и ведение реестра организаций образования по профессиональной подготовке, переподготовке, повышению квалификации и присвоению квалификации по профессиям (специальностям) технического и обслуживающего труда; Пункт 36-1 дополнен в соответствии с решением Съезда от 29.10.2020 г. Протокол №7 ',
  },
  {
    id: '40',
    paid: false,
    name: 'принятие участия в сборе и анализе информации по исполнению недропользователями обязательств по расходам, направляемым на обучение, повышение квалификации и переподготовку работников, являющихся гражданами Республики Казахстан, задействованных при исполнении контракта, или обучение граждан Республики Казахстан по перечню специальностей, согласованному с уполномоченным органом; ',
  },
  {
    id: '41',
    paid: false,
    name: 'совместно с зарубежными организациями образование деловых советов и иных консультативно-совещательных органов в соответствии с законодательством Республики Казахстан и положениями международных договоров; ',
  },
  {
    id: '41-1',
    paid: false,
    name: 'ведение реестра проводимых международных выставок и ярмарок, национальных и региональных выставок и ярмарок, проводимых в Республике Казахстан, а также международных выставок за рубежом, в которых принимает участие Республика Казахстан; ',
  },
  {
    id: '42',
    paid: false,
    name: 'хранение копии сертификата о происхождении товара и документов, подтверждающих происхождение товара, по перечню, утверждаемому государственным органом, осуществляющим государственное регулирование в области технического регулирования, не менее трех лет со дня выдачи сертификата о происхождении товара; ',
  },
  {
    id: '43',
    paid: false,
    name: 'не менее одного раза в год направление в уполномоченный орган в сфере таможенного дела и государственный орган, осуществляющий государственное регулирование в области технического регулирования, образцы оттисков печатей, подписей лиц, уполномоченных заверять сертификаты о происхождении товаров; ',
  },
  {
    id: '44',
    paid: false,
    name: 'определение порядка ведения и ведение реестра субъектов предпринимательства, участников внешнеэкономической деятельности, финансово-экономическое положение которых позволяет определить уровень их надежности как партнеров для предпринимательской деятельности, составленного по согласованию с указанными лицами; Пункт 41-1 дополнен в соответствии с решением Съезда от 29.10.2020 г. Протокол №7 ',
  },
  {
    id: '45',
    paid: false,
    name: 'организация изготовления бланков сертификатов о происхождении товара в соответствии с формами бланков, утвержденными уполномоченным органом в области технического регулирования; ',
  },
  {
    id: '46',
    paid: false,
    name: 'проведение альтернативного анализа регуляторного воздействия в случае несогласия с выводами анализа регуляторного воздейст0вия, проведенного регулирующими государственными органами; ',
  },
  {
    id: '47',
    name: 'Рассмотрение споров в арбитраже в соответствии с законодательными актами Республики Казахстан.',
    paid: true,
  },
  {
    id: '48',
    name: 'Предоставление информации с базы данных товаров, работ, услуг и их поставщиков.',
    paid: true,
  },
  {
    id: '49',
    name: 'Организация торгово-экономической миссии с выездом из РК.',
    paid: true,
  },
  {
    id: '50',
    name: 'Оказание информационных, переводческих и консалтинговых услуг по вопросам внешнеэкономической деятельности.',
    paid: true,
  },
  {
    id: '51',
    name: 'Свидетельствование обстоятельств непреодолимой силы в соответствии с условиями внешнеторговых сделок и международных договоров Республики Казахстан, а также торговых и портовых обычаев, признанных в Республике Казахстан.',
    paid: true,
  },
  {
    id: '52',
    name: 'Выступление гарантом и выдача документов о временном ввозе в соответствии с международными обязательствами Республики Казахстан.',
    paid: true,
  },
  {
    id: '53',
    name: 'Патронаж мероприятия.',
    paid: true,
  },
  {
    id: '54',
    name: 'Организация семинаров, конференций, круглых столов.',
    paid: true,
  },
  {
    id: '55',
    name: 'Организация посещения казахстанских предприятий.',
    paid: true,
  },
  {
    id: '56',
    name: 'Маркетинговые услуги по изучению рынка и популяризации продукта',
    paid: true,
  },
  {
    id: '57',
    name: 'Юридическая экспертиза документов, а также составление договоров, дополнительных соглашений к договорам, протоколов разногласий.',
    paid: true,
  },
  {
    id: '58',
    name: 'Подготовка пакета документов для регистрации/перерегистрации юридического лица, индивидуального предпринимателя.',
    paid: true,
  },
  {
    id: '59',
    name: 'Содействие в регистрации товарных знаков.',
    paid: true,
  },
  {
    id: '60',
    name: 'Разработка локальных нормативных актов и типовых (внутренних) документов организации.',
    paid: true,
  },
  {
    id: '61',
    name: 'Выдача справок об условиях ввоза и вывоза конкретного товара (по коду ТН ВЭД).',
    paid: true,
  },
  {
    id: '62',
    name: 'Оказание консультационных услуг по определению кода товара по ТН ВЭД и таможенной стоимости товара.',
    paid: true,
  },
  {
    id: '63',
    name: 'Юридическое сопровождение деятельности участника внешнеэкономической деятельности по услугам определения кода товара по ТН ВЭД и таможенной стоимости товара в случае необходимости и обращения участника внешнеэкономической деятельности за защитой в суд.',
    paid: true,
  },
  {
    id: '64',
    name: 'Заключение договора поручительства в качестве обеспечения уплаты таможенных пошлин, налогов.',
    paid: true,
  },
  {
    id: '65',
    name: 'Подготовка документов по предложениям участников внешнеэкономической деятельности по пересмотру ставок таможенных пошлин.',
    paid: true,
  },
  {
    id: '66',
    name: 'Организация торгово-экономической миссии в Казахстан для иностранных предпринимателей.',
    paid: true,
  },
  {
    id: '67',
    name: 'Ведение реестра субъектов предпринимательства, участников внешнеэкономической деятельности, финансово-экономическое положение которых позволяет определить уровень их надежности как партнеров для предпринимательской деятельности, составленный по согласованию с указанными лицами.',
    paid: true,
  },
  {
    id: '68',
    name: 'Выдача сертификата о происхождении товара',
    paid: true,
  },
  {
    id: '69',
    name: 'Услуги по обучению основам предпринимательства по проекту "Бастау Бизнес"',
    paid: true,
  },
  {
    id: '70',
    name: 'Регистрация экспортеров в информационных системах стран ввоза товара или внесение изменений в регистрационные данные экспортеров (в части перечня товаров)',
    paid: true,
  },
  {
    id: '71',
    name: 'Услуги на базе реестра бизнес-партнеров и порядок их предоставления отечественным и зарубежным субъектам предпринимательства, государственным органам и иным лицам',
    paid: true,
  },
  {
    id: '72',
    name: 'Перечень и стоимость платных услуг оказываемых Палатами предпринимателей городов Астаны, Шымкента Акмолинской, Восточно- Казахстанской и Карагандинской областей в рамках пилотного проекта по «Частичной коммерциализации услуг»',
    paid: true,
  },
];

function NppServices() {
  const userInfo = useStore($userInfo);
  const { t } = useTranslation();
  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'npp_id',
    },
    {
      title: 'Услуга',
      dataIndex: 'name',
      key: 'npp_name',
      width: 550,
      render: (name, record) => {
        return (
          <ExpandableText
            text={name}
            mmfPayed={userInfo.mmf_payed}
            paid={record.paid}
          />
        );
      },
    },
    {
      title: (
        <div>
          Не оплатил ОЧВ
          <br />
          (Базовая бесплатная версия)
        </div>
      ),
      dataIndex: 'paid',
      key: 'npp_not_paid',
      render: (paid) => {
        if (paid) {
          return (
            <div style={{ textAlign: 'center' }}>
              <CloseCircleFilled style={{ color: '#e2e2e2' }} />
            </div>
          );
        }
        return (
          <div style={{ textAlign: 'center' }}>
            <CheckCircleFilled style={{ color: '#52c41a' }} />
          </div>
        );
      },
    },
    {
      title: (
        <div>
          Оплатил ОЧВ
          <br />
          (Расширенная версия, стоимость 2 МЗП)
        </div>
      ),
      dataIndex: '',
      key: 'npp_paid',
      render: () => (
        <div style={{ textAlign: 'center' }}>
          <CheckCircleFilled style={{ color: '#52c41a' }} />
        </div>
      ),
    },
  ];
  const paymentLoading = useUnit(payOCHVFx.pending);
  const payOCHV = useUnit(payOCHVEv);

  const activeTab = useUnit($servicesActiveTab);
  const changeTab = useUnit(changeServiceActiveTabEv);

  const tabs = [
    {
      label: t('Бесплатные услуги'),
      key: 'free-services',
      children: <FreeServicesTable />,
    },
    {
      label: t('Платные услуги'),
      key: 'paid-services',
      children: <PaidServicesTable />,
    },
    {
      label: t('Премиум поддержка Атамекен'),
      key: 'premium-support',
      children: <PremiumAtameken />,
    },
  ];

  const onPay = () => {
    payOCHV();
  };

  return (
    <>
      {!userInfo.mmf_payed ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 20,
          }}
        >
          <Button type="primary" onClick={onPay} loading={paymentLoading}>
            Оплатить ОЧВ
          </Button>
        </div>
      ) : (
        ''
      )}
      {/* <Table columns={columns} dataSource={dataSource} pagination={false} /> */}
      <Tabs
        items={tabs}
        type="card"
        activeKey={activeTab}
        onChange={changeTab}
      />
    </>
  );
}

export default NppServices;

function ExpandableText({ text, mmfPayed, paid }) {
  const [expanded, setExpanded] = useState(false);

  let styles;
  if (expanded) {
    styles = {
      cursor: 'pointer',
    };
  } else {
    styles = {
      width: 550,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
    };
  }

  return (
    <div
      style={{
        ...styles,
        color: !mmfPayed && paid ? '#e2e2e2' : '#2b3674',
      }}
      onClick={() => setExpanded(!expanded)}
    >
      {text}
    </div>
  );
}
